<div *ngIf="viewLevel === 'groups'" class="mt-1">
  <app-data-table
    #groupTable
    [columnChooser]="true"
    [columns]="groupColumns"
    [data]="bulkOrderGroups"
    [totalRecords]="totalRecords"
    [rows]="rowsPerPage"
    [paginator]="true"
    [lazy]="true"
    emptyMessage="No Records Found"
    [analyticsTab]="'Automated Bulk Upload'"
    (columnSort)="sortGroups($any($event))"
    (pageChange)="onPageChange($event)"
    (rowsChange)="onRowsPerPageChange($event)"
    (rowClick)="viewGroup($event)"
  >
    <ng-template appTableCell="status" let-row>
      <app-status-badge [status]="row.status"></app-status-badge>
    </ng-template>

    <ng-template appTableCell="action" let-row>
      <div appRowActionStop>
        <a
          *ngIf="row.status !== 'AWAITING_APPROVAL'"
          class="viewmore"
          appIconAction
          (click)="viewGroup(row)"
          pTooltip="View Files"
          tooltipPosition="top"
        >
          <i class="pi pi-eye"></i>
        </a>

        <!-- Group AWAITING_APPROVAL → folder-open icon, still navigates to files -->
        <a
          *ngIf="row.status === 'AWAITING_APPROVAL'"
          class="viewmore"
          appIconAction
          (click)="viewGroup(row)"
          pTooltip="Awaiting Approval — Click to View Files"
          tooltipPosition="top"
        >
          <i class="pi pi-folder-open" style="color: #e09007"></i>
        </a>
      </div>
    </ng-template>
  </app-data-table>
</div>

<div *ngIf="viewLevel === 'files'">
  <app-bulk-order-detail
    [group]="selectedGroup"
    [userId]="userId"
    (backClicked)="onBackToGroups()"
  ></app-bulk-order-detail>
</div>
<ng-template #viewOrderData let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">View Order</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="closeView()"
    ></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%">
    <app-view-order
      [viewOrderId]="viewOrderId"
      [isBulkCatUploadOrder]="isBulkCatUploadOrder"
    ></app-view-order>
  </div>
</ng-template>